<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="`IP 관리 범위 ${popupParams.popupType === 'ADD' ?  '추가' : '수정'}`" width="600px" @close="close">
    <div slot="content">
      <el-form label-position="top" label-width="100px" :model="formData" :rules="formRules" ref="ipRangeForm">
        <!-- <el-row>
          <el-form-item label="IP 주소" prop="ipaddress">
            <el-input v-model="formData.ipaddress" @change="onInputChange"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="서브넷 마스크" prop="subnetmask">
            <el-select v-model="formData.subnet" value-key="basicinfoSubid" @change="onSelectChange" :disabled="true">
              <el-option v-for="subnetmask in subnetmaskList" :key="subnetmask.basicinfoSubid" :value="subnetmask.basicinfoSubid" :label="subnetmask.basicinfoSubname"></el-option>
            </el-select>
          </el-form-item>
        </el-row> -->
        <el-form-item label="IP 대역">
            <el-col :span="11">
              <el-form-item prop="startIpaddress">
                <el-input v-model="formData.startIpaddress" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" class="mr-t4" style="text-align: center"> ~ </el-col>
            <el-col :span="11">
              <el-form-item prop="endIpaddress">
                <el-input v-model="formData.endIpaddress" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
        </el-form-item>
        <el-row>
          <el-form-item label="서브넷 마스크" prop="subnet">
            <el-input v-model="formData.subnet" style="width: 100%"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="게이트웨이" prop="gateway">
            <el-input v-model="formData.gateway" style="width: 100%"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="DNS" prop="dns">
            <el-input v-model="formData.dns" style="width: 100%"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" size="large" type="solid" :disabled="saveButtonDisabled" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
// import basicinfoSubAPI from '@/api/model/basicinfo-sub';
import provisioningAPI from '@/api/settings/virtual/provisioning-settings';

export default {
  name: 'WAddIpRangePopup',
  props: {
    selectedNode: {
      type: Object,
    },
    popupParams: {
      type: Object,
    },
  },
  data() {
    const validateIp = (rule, value, callback) => {
      if (isNil(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (!validateIpv4(value) && !validateIpv6(value)) {
        callback(new Error('올바른 IPv4 혹은 IPv6 주소형식을 입력해주세요'));
      }
      callback();
    };
    return {
      saveButtonDisabled: false,
      // subnetmaskList: [],
      originData: null,
      formData: {
        // ipaddress: '',
        startIpaddress: '',
        endIpaddress: '',
        subnet: '',
        gateway: '',
        dns: '',
      },
      formRules: {
        // ipaddress: {
        //   required: true,
        //   trigger: 'blur',
        //   validator: validateIp,
        // },
        startIpaddress: {
          required: true,
          trigger: 'blur',
          validator: this.validateStartIp,
        },
        endIpaddress: {
          required: true,
          trigger: 'blur',
          validator: this.validateEndIp,
        },
        subnet: {
          required: true,
          trigger: 'blur',
          validator: validateIp,
        },
        gateway: {
          required: true,
          trigger: 'blur',
          validator: validateIp,
        },
        dns: {
          required: true,
          trigger: 'blur',
          validator: validateIp,
        },
      },
    };
  },
  watch: {
    formData: {
      handler() {
        if (this.popupParams.popupType === 'ADD') return;
        this.saveButtonDisabled = isEqual(this.formData, this.originData);
      },
      deep: true,
    },
  },
  methods: {
    open() {
      // this.loadData();
      this.$nextTick(() => {
        if (this.popupParams.popupType === 'UPDATE') {
          const selectedRow = this.popupParams.selectedRow;
          this.formData = {
            startIpaddress: selectedRow.startIpaddress,
            endIpaddress: selectedRow.endIpaddress,
            subnet: selectedRow.subnet,
            gateway: selectedRow.gateway,
            dns: selectedRow.dns,
          };
          this.originData = cloneDeep(this.formData);
          this.saveButtonDisabled = true;
        }
        this.$refs.slidingPopup.visible = true;
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.ipRangeForm.clearValidate();
      this.saveButtonDisabled = false;
      this.formData = {
        startIpaddress: '',
        endIpaddress: '',
        subnet: '',
        gateway: '',
        dns: '',
      };
    },
    // loadData() {
    //   basicinfoSubAPI.getList('SUBNETMASK').then((response) => {
    //     if (response.data.success) {
    //       this.subnetmaskList = response.data.data;
    //     }
    //   });
    // },
    /**
     * IP 대역 시작 IP 유효성 검사
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateStartIp(rule, value, callback) {
      const endIpaddress = this.formData.endIpaddress;
      const endIpStr = endIpaddress.split('.');
      if (isNil(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (!validateIpv4(value) && !validateIpv6(value)) {
        callback(new Error('올바른 IPv4 혹은 IPv6 주소형식을 입력해주세요'));
      } else if (endIpaddress !== '' && ((endIpStr[0] !== value.split('.')[0]) || (endIpStr[1] !== value.split('.')[1]) || (endIpStr[2] !== value.split('.')[2]))) {
        callback(new Error('시작 IP 형식을 확인해주세요'));
      } else if (Number(value.split('.')[3]) >= Number(endIpStr[3])) {
        callback(new Error('시작 IP 형식을 확인해주세요'));
      } else if (value.split('.')[3] === '0') {
        callback(new Error('시작 IP 형식을 확인해주세요'));
      }
      callback();
    },
    /**
     * IP 대역 종료 IP 유효성 검사
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateEndIp(rule, value, callback) {
      const startIpaddress = this.formData.startIpaddress;
      const startIpStr = startIpaddress.split('.');
      if (isNil(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (!validateIpv4(value) && !validateIpv6(value)) {
        callback(new Error('올바른 IPv4 혹은 IPv6 주소형식을 입력해주세요'));
      } else if (startIpaddress !== '' && ((startIpStr[0] !== value.split('.')[0]) || (startIpStr[1] !== value.split('.')[1]) || (startIpStr[2] !== value.split('.')[2]))) {
        callback(new Error('종료 IP 형식을 확인해주세요'));
      } else if (Number(startIpStr[3]) >= Number(value.split('.')[3])) {
        callback(new Error('종료 IP 형식을 확인해주세요'));
      } else if (value.split('.')[3] === '255') {
        callback(new Error('종료 IP 형식을 확인해주세요'));
      }
      callback();
    },
    onSaveButtonClick() {
      this.$refs.ipRangeForm.validate((valid) => {
        if (valid) {
          const target = 'IP 관리범위';
          const action = this.popupParams.popupType === 'ADD' ? msgUtil.action.ADD : msgUtil.action.MODIFY;
          const hostId = this.selectedNode.treeKey.split('.')[1];
          let params = { hostId: Number(hostId), ...this.formData };

          if (this.popupParams.popupType === 'UPDATE') {
            params = { rangeId: this.popupParams.selectedRow.rangeId, ...params };
          }

          provisioningAPI.insertVmsHostIpRange(params).then((response) => {
            if (response.data.success) {
              this.$emit('re-load');
              this.close();
            }
            this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
        }
      });
    },
    // onInputChange() {
    //   const ipaddress = this.formData.ipaddress;
    //   const subnetbit = this.formData.subnet;
    //   if (ipaddress && subnetbit) {
    //     this.getDHCPList(ipaddress, subnetbit);
    //   }
    // },
    // onSelectChange() {
    //   const ipaddress = this.formData.ipaddress;
    //   const subnetbit = this.formData.subnet;
    //   if (ipaddress && subnetbit) {
    //     this.getDHCPList(ipaddress, subnetbit);
    //   }
    // },
    // /**
    //  * ip주소와 subnetbit로 ip대역 계산
    //  * @author jeee12
    //  * @return {[type]} [description]
    //  */
    // getDHCPList(ipaddress, subnetbit) {
    //   this.$refs.ipRangeForm.validateField('ipaddress', (error) => {
    //     if (!error && !isNil(subnetbit)) {
    //       provisioningAPI.getDHCPList({ ipaddress, subnetbit: parseInt(subnetbit, 10) }).then((response) => {
    //         if (response.data.success) {
    //           const result = response.data.data;
    //           this.formData.startIpaddress = result.dhcpStart;
    //           this.formData.endIpaddress = result.dhcpEnd;
    //         }
    //       });
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/IpRangeSetting/popup/AddIpRangePopup.vue